import managementReducer from './reducers';

export { default as managementOperations } from './operations';
export { default as homeTypes } from './types';
export default managementReducer;